(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('statisticsService',statisticsService);

    statisticsService.$inject = ['$http', 'CONFIG','messageService'];

    function statisticsService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/traffic';

        var service = {
            getTrafficOriginDestiny: getTrafficOriginDestiny,
            getTrafficByStages: getTrafficByStages
        };

        return service;

        function getTrafficOriginDestiny(fromDate, toDate, detail){
            return $http.get(urlBase + '/originDestiny' + '?fromDate='+fromDate + '&toDate=' + toDate + '&detail=' + detail)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getTrafficByStages(fromDate, toDate, detail){
            return $http.get(urlBase + '/stage' + '?fromDate='+fromDate + '&toDate=' + toDate + '&detail=' + detail)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
